import { render, staticRenderFns } from "./AppHorizontalMenus.vue?vue&type=template&id=a44fec14"
import script from "./AppHorizontalMenus.vue?vue&type=script&lang=js"
export * from "./AppHorizontalMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../routestatus/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports